<template>
  <div class="dt-container w-100">
    <div ref="toolbar" role="group" aria-label="Lift table actions"></div>
    <!-- DataTables copy needs a rendered container so its textarea can receive focus. -->
    <div ref="exportSource" class="sr-only" aria-hidden="true"></div>
  </div>
</template>

<script>
import $ from "jquery";
import { markRaw } from "vue";
import TableService from "../../services/table.service";

export default {
  name: "LiftTableActions",
  props: {
    tableData: { type: Object, required: true },
    metricColumns: { type: Array, required: true },
    filename: { type: String, default: "Lift Map Table" },
    snapshotContainerId: { type: String, required: true }
  },
  data() {
    return { exportTable: null, reportPageTypeName: "Table - Lift Map" };
  },
  mounted() {
    this.buildToolbar();
  },
  beforeUnmount() {
    this.destroyToolbar();
  },
  methods: {
    percent(value, digits, percent = true) {
      return typeof value === "number" && Number.isFinite(value) ? value.toFixed(digits) + (percent ? "%" : "") : "";
    },
    exportRows() {
      const rows = this.tableData.rows.map(row => [
        row.rank, row.label, row.need,
        ...this.metricColumns.map(column => this.percent(row[column.field], column.digits, column.percent !== false))
      ]);
      const summary = this.tableData.summary || {};
      const averages = summary.averages || {};
      rows.push(
        ["", "", "Premium", this.percent(summary.premiumWtp, 2), "Averages",
          ...["inDemand", "untapped", "tableStake", "watch"].map(field => this.percent(averages[field], 1)), ""],
        ["", "", "Table Stake", this.percent(summary.tableStakeWtp, 2), "", "", "", "", "", ""],
        ["", "", "Growth Total", this.percent(summary.growthTotalWtp, 2), "", "", "", "", "", ""]
      );
      return rows.map(row => row.concat(Array(Math.max(0, 3 + this.metricColumns.length - row.length)).fill("")));
    },
    destroyToolbar() {
      if (this.exportTable) {
        this.exportTable.destroy(true);
        this.exportTable = null;
      }
      $(this.$refs.toolbar).empty();
      $(this.$refs.exportSource).empty();
    },
    buildToolbar() {
      if (!this.$refs.toolbar) return;
      this.destroyToolbar();
      // Keep DataTables' DOM management separate from the visible, Vue-rendered table.
      const table = $("<table>").appendTo(this.$refs.exportSource);
      const buttons = TableService.getTableButtons(
        this, this.snapshotContainerId, "", this.reportPageTypeName, false, this.filename
      );
      buttons.buttons.forEach(button => {
        button.attr = { "aria-label": button.titleAttr };
      });
      this.exportTable = markRaw(table.DataTable({
        data: this.exportRows(),
        columns: ["RANK", "Label", "Need", ...this.metricColumns.map(column => column.label)]
          .map(title => ({ title, render: $.fn.dataTable.render.text() })),
        ordering: false,
        paging: false,
        searching: false,
        info: false,
        autoWidth: false,
        deferRender: false,
        dom: "B",
        buttons
      }));
      this.exportTable.buttons().container().appendTo(this.$refs.toolbar);
    }
  },
  watch: {
    tableData: { deep: true, handler() { this.buildToolbar(); } },
    metricColumns: { deep: true, handler() { this.buildToolbar(); } },
    filename() { this.buildToolbar(); }
  }
};
</script>
